<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2z"><a id="ack"></a><strong>Acknowledgments</strong></h2>
<p class="noindent">Thanks to Tom Condon, my editor at the <em>Hartford Courant</em>, where many of these pieces originally appeared in a different form. His interest and insight into Connecticut’s landscape is unrivaled.</p>
<p class="indent">Deep gratitude to my brother firefighter Juan C. Gonzalez for his friendship and magic with computers, which has more than once saved my words from disintegrating into cyberspace and has preserved my sanity despite the most perplexing (to me, at least) technical problems. I’ll try not to bang on my keyboard as if it were the mechanical Underwood typewriter I learned on.</p>
<p class="indent">Thanks to Bill Keegan, historical geographer and GIS specialist, for his generous contribution of time and expertise. Not only can he see spatially, but in time as well.</p>
<p class="indent">My appreciation goes to the librarians at my hometown Canton Public Library, especially Beth Van Ness. I value her friendship and admire her patience with my frequent requests to track down obscure facts, books, and documents.</p>
<p class="indent">Finally, I’m grateful to my friends Alan Weiner and Bette Abrams-Esche, boon companions on many a bizarre quest.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?243835d0